import React from "react";
import * as S from "./styles";

const Title = ({ children, htmlTag = "default" }) => {
  const render = {
    h1: <S.H1>{children}</S.H1>,
    h2: <S.H2>{children}</S.H2>,
    h3: <S.H3>{children}</S.H3>,
    h4: <S.H4>{children}</S.H4>,
    h5: <S.H5>{children}</S.H5>,
    h6: <S.H6>{children}</S.H6>,
    default: null,
  };

  return <>{render[htmlTag] || render["default"]}</>;
};

export default Title;
